import { Controller } from "@hotwired/stimulus"

// Live diff for the migration commit form. Keeps "Verify & commit" disabled
// until every old-system total matches what we carried and the file has no row
// errors. The server enforces the same rule in Migrations::Importer#commit!.
export default class extends Controller {
  static targets = ["tenants", "owed", "credits", "tenantsDiff", "owedDiff", "creditsDiff", "netDiff", "submit"]
  static values = { tenants: Number, owed: Number, credits: Number, rowErrors: Number }

  connect() { this.check() }

  // "$1,234.50", "-45.00", "(45.00)", "45.00-" -> cents; null when blank/unreadable.
  cents(raw) {
    let t = (raw || "").replace(/[$,\s]/g, "")
    if (t === "") return null
    let neg = false
    const paren = t.match(/^\((.*)\)$/)
    if (paren) { neg = true; t = paren[1] }
    if (/^[-+]/.test(t)) { if (neg) return null; neg = t[0] === "-"; t = t.slice(1) }
    else if (t.endsWith("-")) { if (neg) return null; neg = true; t = t.slice(0, -1) }
    if (!/^(\d+(\.\d*)?|\.\d+)$/.test(t)) return null
    const c = Math.round(parseFloat(t) * 100)
    return neg ? -c : c
  }

  money(c) { return (c < 0 ? "-" : "") + "$" + (Math.abs(c) / 100).toFixed(2) }

  check() {
    const count = /^\d+$/.test(this.tenantsTarget.value.trim()) ? parseInt(this.tenantsTarget.value, 10) : null
    const owed = this.cents(this.owedTarget.value)
    let credits = this.cents(this.creditsTarget.value)
    if (credits !== null) credits = Math.abs(credits)

    this.tenantsDiffTarget.textContent = count === null ? "—" : String(count - this.tenantsValue)
    this.owedDiffTarget.textContent = owed === null ? "—" : this.money(owed - this.owedValue)
    this.creditsDiffTarget.textContent = credits === null ? "—" : this.money(credits - this.creditsValue)
    const ready = count !== null && owed !== null && credits !== null && owed >= 0
    const net = ready ? (owed - credits) - (this.owedValue - this.creditsValue) : null
    this.netDiffTarget.textContent = net === null ? "—" : this.money(net)

    this.submitTarget.disabled = !(ready && this.rowErrorsValue === 0 &&
      count === this.tenantsValue && owed === this.owedValue && credits === this.creditsValue)
  }
}
